import { useMedicareUrl } from 'hooks/useMedicareUrl'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Divider } from '../../../../components/Divider/Divider'

interface ResourceList {
  text: string
  link: string
}

interface RelatedResourceSectionProps {
  heading: string
  list: ResourceList[]
}

const RelatedResourceSection: FC<RelatedResourceSectionProps> = ({ heading, list }) => {
  return (
    <div style={{
      flex: 1
    }}
    >
      <Divider className='my-u-my--12' />
      <h3 className='my-u-m--0 my-u-mb--10 ds-text-heading--xl'>{heading}</h3>
      <ul
        className='ds-u-margin--0 ds-u-padding--0' style={{
          listStyle: 'none'
        }}
      >
        {list.map(({ text, link }) => <li key={text} className='my-u-mb--10'><a href={link}>{text}</a></li>)}
      </ul>
    </div>
  )
}

export const RelatedResources: FC = () => {
  const { t } = useTranslation('eMSNPage')
  const howToReadUrl = useMedicareUrl(
    'https://www.medicare.gov/forms-help-resources/mail-you-get-about-medicare/medicare-summary-notice-msn',
    'https://es.medicare.gov/forms-help-resources/mail-you-get-about-medicare/medicare-summary-notice-msn'
  )
  const goPaperlessUrl = useMedicareUrl(
    'https://www.medicare.gov/mbp/editcommunicationsettings.aspx?Lang=en-us',
    'https://www.medicare.gov/mbp/editcommunicationsettings.aspx?Lang=es-mx'
  )
  const howToSpotMedicareFraudUrl = useMedicareUrl(
    'https://www.medicare.gov/forms-help-resources/help-fight-medicare-fraud/how-spot-medicare-fraud',
    'https://es.medicare.gov/forms-help-resources/help-fight-medicare-fraud/how-spot-medicare-fraud'
  )
  const medicareCostUrl = useMedicareUrl(
    'https://www.medicare.gov/your-medicare-costs',
    'https://es.medicare.gov/your-medicare-costs'
  )
  const helpPayingCostsUrl = useMedicareUrl(
    'https://www.medicare.gov/your-medicare-costs/get-help-paying-costs',
    'https://es.medicare.gov/your-medicare-costs/get-help-paying-costs'
  )
  const fileAppealUrl = useMedicareUrl(
    'https://www.medicare.gov/claims-appeals/how-do-i-file-an-appeal',
    'https://es.medicare.gov/claims-appeals/how-do-i-file-an-appeal'
  )
  const thingsToKnowUrl = useMedicareUrl(
    'https://www.medicare.gov/claims-appeals/file-an-appeal/5-things-to-know-when-filing-an-appeal',
    'https://es.medicare.gov/claims-appeals/file-an-appeal/5-things-to-know-when-filing-an-appeal'
  )
  const helpFilingUrl = useMedicareUrl(
    'https://www.medicare.gov/claims-appeals/file-an-appeal/can-someone-file-an-appeal-for-me',
    'https://es.medicare.gov/claims-appeals/file-an-appeal/can-someone-file-an-appeal-for-me'
  )
  return (
    <div className='my-u-mt--30 my-u-mb--40'>
      <h2 className='ds-text-heading--xl my-u-m--0'>{t('related-resources.heading')}</h2>
      <div
        className='ds-u-display--flex ds-u-flex-direction--column ds-u-md-flex-direction--row' style={{
          gap: '20px'
        }}
      >
        <RelatedResourceSection
          heading={t('related-resources.emsns-heading')} list={[
            {
              text: t('related-resources.how-to-read'),
              link: howToReadUrl
            },
            {
              text: t('related-resources.go-paperless'),
              link: goPaperlessUrl
            },
            {
              text: t('related-resources.learn-how'),
              link: howToSpotMedicareFraudUrl
            }
          ]}
        />
        <RelatedResourceSection
          heading={t('related-resources.learn-more-heading')} list={[
            {
              text: t('related-resources.medicare-costs'),
              link: medicareCostUrl
            },
            {
              text: t('related-resources.help-paying-costs'),
              link: helpPayingCostsUrl
            }
          ]}
        />
        <RelatedResourceSection
          heading={t('related-resources.appeals-heading')} list={[
            {
              text: t('related-resources.file-appeal'),
              link: fileAppealUrl
            },
            {
              text: t('related-resources.things-to-know'),
              link: thingsToKnowUrl
            },
            {
              text: t('related-resources.help-filing'),
              link: helpFilingUrl
            }
          ]}
        />
      </div>
    </div>
  )
}
